import { HttpEvent, HttpEventType, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable, tap } from 'rxjs';


export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return next(req).pipe(tap(event => {
    //console.log(req.method,req.url, 'returned ', event);
    if (event.type === HttpEventType.Response && req.method !== "GET") {
      //console.log(req.method, req.url, 'returned a response with status',req.body, event.status);

    }
  }));
}